// src/hooks/useBookmarks.js

import { useState, useEffect } from 'react';

const BOOKMARK_KEY = 'cromptonBookmarkedRecipes';

const useBookmarks = () => {
    const [bookmarks, setBookmarks] = useState([]);

    // ✅ Load from localStorage on mount
    useEffect(() => {
        try {
            const stored = localStorage.getItem(BOOKMARK_KEY);
            if (stored) {
                setBookmarks(JSON.parse(stored));
            }
        } catch (error) {
            console.error('Error loading bookmarks:', error);
            setBookmarks([]);
        }
    }, []);

    // ✅ Save to localStorage on every change
    useEffect(() => {
        try {
            localStorage.setItem(BOOKMARK_KEY, JSON.stringify(bookmarks));
        } catch (error) {
            console.error('Error saving bookmarks:', error);
        }
    }, [bookmarks]);

    // ✅ Check if recipe is bookmarked
    const isBookmarked = (recipeId) => {
        return bookmarks.some((b) => b.recipeId === recipeId);
    };

    // ✅ Toggle bookmark
    const toggleBookmark = (recipe) => {
        setBookmarks((prev) => {
            const alreadyBookmarked = prev.some((b) => b.recipeId === recipe.recipeId);
            if (alreadyBookmarked) {
                return prev.filter((b) => b.recipeId !== recipe.recipeId);
            } else {
                return [...prev, recipe];
            }
        });
    };

    // ✅ Total bookmark count
    const bookmarkCount = bookmarks.length;

    return { bookmarks, isBookmarked, toggleBookmark, bookmarkCount };
};

export default useBookmarks;